import { expandedState } from '@atlaskit/editor-common/expand';
import { fg } from '@atlaskit/platform-feature-flags';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
export var updateExpandedStateNew = function updateExpandedStateNew(_ref) {
  var tr = _ref.tr,
    node = _ref.node,
    pos = _ref.pos,
    isLivePage = _ref.isLivePage;
  if (isLivePage || fg('platform-editor-single-player-expand')) {
    var wasExpandExpanded = expandedState.get(node);
    var newExpand = tr.doc.nodeAt(pos);
    if (wasExpandExpanded !== undefined && newExpand) {
      expandedState.set(newExpand, wasExpandExpanded);
    }
  }
};
export var updateExpandedState = function updateExpandedState(tr, node, isLivePage) {
  if (editorExperiment('platform_editor_breakout_resizing', true)) {
    updateExpandedStateNew({
      tr: tr,
      node: node.node,
      pos: node.pos,
      isLivePage: isLivePage
    });
  } else {
    if (isLivePage || fg('platform-editor-single-player-expand')) {
      var wasExpandExpanded = expandedState.get(node.node);
      var newExpand = tr.doc.nodeAt(node.pos);
      if (wasExpandExpanded !== undefined && newExpand) {
        expandedState.set(newExpand, wasExpandExpanded);
      }
    }
  }
};